export const bcComponentsConstants = {
  TIMER_DELAY: 10,
  TIMER_DELAY_HIGHLIGHT: 30,
  TIMER_CLASSNAME_UNANSWERED: 'unanswered-color',
  TIMER_CLASSNAME_WRAPUP: 'wrapup-color',
  TIMER_CLASSNAME_HIGHLIGHT: 'highlight'
};
